<template>
    <div
      class="common-popup product-common-popup"
      :class="{
        unfix: !fixFlag,
        bankabc: clientEnv.isBankabc,
        backOut: backOut,
        'vivo-app-no-os-4': isVivoAppNoOS4
      }"
    >
      <div class="header">
        <div class="header-bar" :style="{ paddingTop: `${nativeHeight}px` }" v-statusBarHeight:[use]="'paddingTop'">
          <div class="container">
            <div class="icon back" role="button" tabindex="0" aria-label="返回" @click="closeFn" v-if="!isHide">
              <v-icon class="icon-back" name="arrow-left-v3"></v-icon>
            </div>
            <div class="navigator" :class="{ 'navigator-buy': isThreeDimensional }">
              <div class="line" role="region">
                <div class="text lc-1">{{ title }}</div>
                <div class="sub-title" v-if="subTitle">{{ subTitle }}</div>
              </div>
            </div>
            <div :class="['buy', canBuy ? '' : 'gray']" v-if="isThreeDimensional" @click="buy">
              {{ canBuy ? '购买' : '暂不销售' }}
            </div>
            <div
              v-if="!isThreeDimensional && !isHide"
              class="icon menu"
              :style="{ visibility: !isApp && menu ? '' : 'hidden' }"
              @click="toggleShowMenu"
            >
              <v-icon class="i-menu" name="icon-menu-v3"></v-icon>
            </div>
          </div>
        </div>
        <slot v-if="$slots.headerExtra" name="headerExtra" />
      </div>
      <!-- 错误页面 -->
      <div v-if="isShowPageError" class="page-error">
        <v-empty type="error">
          <div class="option btn-group">
            <nx-button @click="retry" type="frame-plus">点击重试</nx-button>
            <nx-button @click="returnHome" type="frame-plus">返回首页</nx-button>
          </div>
        </v-empty>
      </div>
      <template v-if="!isShowPageError && pageInit">
        <v-list-loading class="loading" v-if="loading"></v-list-loading>
        <template v-if="listenScroll">
          <div
            ref="scrollContentRef"
            :class="['content', isThreeDimensional ? 'no-padding-bottom' : '',{'is-pad-app': clientEnv.isPadVivoApp}]"
            @click="isShowMenu = false"
            :style="{ display, marginTop: fixFlag ? '' : `${nativeHeight}px` }"
            @scroll="handleScroll"
          >
            <slot></slot>
          </div>
        </template>
        <div
          :class="['content', isThreeDimensional ? 'no-padding-bottom' : '',{'is-pad-app': clientEnv.isPadVivoApp}]"
          @click="isShowMenu = false"
          :style="{ display, marginTop: fixFlag ? '' : `${nativeHeight}px` }"
          v-else
        >
          <slot></slot>
        </div>
      </template>
    </div>
</template>

<script>
import { app } from '@/utils'
import shop from '@/utils/shop'
import clientEnv from '@/utils/clientEnv'
import { Button } from '@vivo/vos-ui'
export default {
  name: 'ServicePopup',
  components: {
    [Button.name]: Button
  },
  props: {
    // 是否错误页面
    pageError: {
      type: Boolean,
      default: false
    },
    // 是否完成初始化
    pageInit: {
      type: Boolean,
      default: true
    },
    title: String,
    subTitle: String,
    menu: {
      type: Boolean,
      default: true
    },
    isThreeDimensional: {
      type: Boolean,
      default: false
    },
    // 是否可以购买
    canBuy: {
      type: Boolean,
      default: false
    },
    preventCrash: {
      type: Boolean,
      default: false
    },
    backOut: {
      type: Boolean,
      default: false
    },
    pageTitle: {
      type: String,
      default: '很抱歉，服务器开小差了~'
    },
    // 是否采用绝对定位（仅在评价列表页使用）
    fixFlag: {
      type: Boolean,
      default: true
    },
    // content是否增加滚动监听
    listenScroll: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // 官网app且不是OS4系统
    isVivoAppNoOS4() {
      return clientEnv.isVivoApp && !clientEnv.isOS4 && !clientEnv.isIOSVivoApp
    },
    /**
     * 判断是否为App且版本大于920，样式进行调整
     */
    isApp() {
      return app.checkVersion(920)
    },
    isHide() {
      return shop.hidenShopHeader()
    },
    isShowPageError() {
      // 如果全局pageError状态为true，则直接显示错误页，否则，判断page组件pageError状态
      return this.$store.state.pageError || this.pageError
    },
    errorTitle() {
      // 如果全局pageError状态为true，则直接显示错误页，否则，判断page组件pageError状态
      return this.$store.state.pageTitle || this.pageTitle
    }
  },
  data() {
    return {
      isShowMenu: false,
      clientEnv,
      use: !clientEnv.isIOSVivoApp,
      nativeHeight: 0,
      display: clientEnv.isIOS && this.preventCrash ? 'none' : undefined,
      loading: false
    }
  },
  methods: {
    retry() {
      location.reload()
    },
    returnHome() {
      location.href = `${this.linkBase}/index.html`
    },
    /**
     * 关闭弹框
     */
    closeFn() {
      this.$emit('close')
    },

    /**
     * 显示、隐藏菜单
     */
    toggleShowMenu() {
      this.isShowMenu = !this.isShowMenu
    },

    /**
     * 购买
     */
    buy() {
      if (this.canBuy) this.$emit('buy')
    },

    getNativeHeight() {
      if (clientEnv.isIOSVivoApp) {
        app.getTitleBarHeight({
          type: 'statusBarHeight',
          success: res => {
            this.nativeHeight = res
          }
        })
      }
    },

    frameLoad() {
      this.display = undefined
      this.loading = false
    },
    handleScroll(e){
      this.$emit('scroll', e)
    }
  },
  created() {
    if (clientEnv.isIOS && this.preventCrash) {
      this.loading = true
    }
  },
  mounted() {
    this.getNativeHeight()
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
